<template>
  <div v-if="this.language == 'eng'">
    <waterfall :col="col" :data="data">
      <template>
        <div
          class="cell-item wow animate__fadeInDown animate__animated"
          @click="goDetail(item.id)"
          v-for="(item, index) in data"
          :key="index"
        >
          <img
            class="image"
            v-if="item.watermark.length>0"
            :src="url + item.watermark[0].fileUrl"
          />
          <img v-else src="" alt="暂无图片" />
          <div class="item-body">
            <div class="item-desc">{{ item.title }}</div>
            <div class="item-footer">
              <div class="footer-left eng_footer-left">
                <img
                  v-if="item.authorPicture"
                  :src="url + item.authorPicture.thinUrl"
                />
                <div class="noneImage" v-else></div>
                <div class="name">{{ item.englishName }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </waterfall>
  </div>
  <div v-else-if="this.language == 'en'">
    <waterfall :col="col" :data="data">
      <template>
        <div
          class="cell-item wow animate__fadeInDown animate__animated"
          @click="goDetail(item.id)"
          v-for="(item, index) in data"
          :key="index"
        >
          <img
            class="image"
            v-if="item.watermark.length>0"
            :src="url + item.watermark[0].fileUrl"
          />
          <img v-else src="" alt="གནས་སྐབས་པར་རིས་མེད་།" />
          <div class="item-body">
            <div class="item-desc">{{ item.title }}</div>
            <div class="item-footer">
              <div class="footer-left">
                <img
                  v-if="item.authorPicture"
                  :src="url + item.authorPicture.thinUrl"
                />
                <div class="noneImage" v-else></div>
                <div class="name">{{ item.zangName }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </waterfall>
  </div>
  <div v-else>
    <waterfall :col="col" :data="data">
      <template>
        <div
          class="cell-item wow animate__fadeInDown animate__animated"
          @click="goDetail(item.id)"
          v-for="(item, index) in data"
          :key="index"
        >
          <img
            class="image"
            v-if="item.watermark.length>0"
            :src="url + item.watermark[0].fileUrl"
          />
          <img v-else src="" alt="暂无图片" />
          <div class="item-body">
            <div class="item-desc">{{ item.title }}</div>
            <div class="item-footer">
              <div class="footer-left">
                <img
                  v-if="item.authorPicture"
                  :src="url + item.authorPicture.thinUrl"
                />
                <div class="noneImage" v-else></div>
                <div class="name">{{ item.chineseName }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </waterfall>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      url: process.env.VUE_APP_WEB_URL,
      col: 3,
      language: this.$store.state.language,
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  mounted() {
    new this.$wow.WOW().init();
  },
  methods: {
    goDetail(id) {
      this.$router.push({ path: "/exhibitionWorkDetail", query: { id: id } });
    },
  },
};
</script>
<style lang="scss">
.vue-waterfall-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  .cell-item {
    padding: 8px;
    width: 85%;
    margin: 40px 0;
    background: #ffffff;
    border: none !important;
    border-radius: 0 !important;
    box-sizing: border-box;
    overflow: hidden;
    .image {
      width: 100%;
      height: auto;
      display: block;
      transition: all 500ms ease;
    }
    .item-body {
      margin: 9px;
      .item-desc {
        text-align: left;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #000000;
      }
      .item-footer {
        display: flex;
        justify-content: space-between;
        .footer-left {
          display: flex;
          align-items: center;
          font-style: normal;
          font-weight: normal;
          line-height: 14px;
          color: #3b4d66;
          font-size: 18px;
          font-family: "fangzang";
          img {
            border-radius: 50%;
            width: 45px;
            height: 45px;
            margin-right: 10px;
          }
          .noneImage {
            border-radius: 50%;
            width: 45px;
            height: 45px;
            margin-right: 10px;
            border: 1px solid #f0f0f0;
          }
          .name {
            line-height: 20px;
            width: calc(100% - 55px);
            overflow: hidden; 
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
        .eng_footer-left {
          font-family: "Times New Roman", Times, serif;
        }
        .like {
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: SF Pro Display;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 14px;
          color: rgba(0, 0, 0, 0.4);
          img {
            margin-right: 4px;
          }
        }
      }
    }
  }
  .cell-item:hover {
    box-shadow: 0 0 15px #a8a8a8;
    .image {
      transform: scale(1.05);
    }
  }
}
</style>